// extracted by mini-css-extract-plugin
export default {"page":"EventSearch_page__frXfR","form":"EventSearch_form__UtX3z","legend":"EventSearch_legend__TUPTu"};